export const GET_COUPON_LIST = 'coupon/GET_COUPON_LIST';
export const SET_COUPON_LIST = 'coupon/SET_COUPON_LIST';
export const COUPON_LIST_LOADED = 'coupon/COUPON_LIST_LOADED';
export const CREATE_COUPON = 'coupon/CREATE_COUPON';
export const EDIT_COUPON = 'coupon/EDIT_COUPON';
export const REMOVE_COUPON = 'coupon/REMOVE_COUPON';
export const VALIDATE_COUPON = 'coupon/VALIDATE_COUPON';
export const CONSUME_COUPON = 'coupon/CONSUME_COUPON';
export const COUPON_DISCOUNT = 'coupon/COUPON_DISCOUNT';

export const COUPON_IS_CREATED = 'coupon/COUPON_IS_CREATED';
export const COUPON_IS_EDITED = 'coupon/COUPON_IS_EDITED';
export const COUPON_IS_DELETED = 'coupon/COUPON_IS_DELETED';
export const COUPON_IS_VALID = 'coupon/COUPON_IS_VALID';
export const COUPON_IS_CONSUMED = 'coupon/COUPON_IS_CONSUMED';